import { CHARTV2_HORIZON_SPAN_MS } from '../constants';
import type { ChartV2Horizon, ChartV2Point } from '../types/chart-v2.types';

export const horizonToDomain = (
  horizon: ChartV2Horizon,
  latest: number,
  earliest: number
): { start: number; end: number } => {
  const end = latest;

  if (horizon === 'MAX') {
    return { start: earliest, end };
  }

  const span = CHARTV2_HORIZON_SPAN_MS[horizon];

  if (span == null) {
    return { start: earliest, end };
  }

  return { start: Math.max(end - span, earliest), end };
};

export const isOhlcPoint = (
  p: ChartV2Point
): p is Extract<ChartV2Point, { open: number }> => 'open' in p && 'close' in p;

export const pointValue = (p: ChartV2Point): number =>
  isOhlcPoint(p) ? p.close : p.value;

export const clamp = (x: number, lo: number, hi: number): number =>
  Math.max(lo, Math.min(hi, x));

export const bisectLeft = (arr: number[], value: number): number => {
  let lo = 0;
  let hi = arr.length;

  while (lo < hi) {
    const mid = (lo + hi) >>> 1;

    if (arr[mid] < value) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};

export const devicePixelRatioSafe = (): number =>
  typeof window !== 'undefined' && window.devicePixelRatio
    ? window.devicePixelRatio
    : 1;
